import { useBacklogSelector } from '../index.tsx';
import { getIsCompanyManaged, isCmpKanbanProject } from '../selectors/app/index.tsx';

export const useIsCMPBacklog = () => useBacklogSelector(getIsCompanyManaged);

export const useIsCMPKanbanBacklog = () => useBacklogSelector(isCmpKanbanProject);
